<button class="btn btn-sm btn-primary me-1 mb-1" title="Roster Download"
  (click)="downloadCsv()">
  <i class="fas fa-file-csv"></i> Roster<span class="sr-only">Roster Download</span>
  @if (profileService.rosterDownloading[sectionId]) {
    <i class="fas fa-circle-notch fa-spin"></i>
  }
</button>
<button class="btn btn-sm btn-primary me-1 mb-1" title="Print Biobooks" (click)="downloadBiobooks()">
  <i class="fal fa-portrait"></i> Bios<span class="sr-only">Biobooks Download</span>
  @if (profileService.bioBookDownloading[sectionId]) {
    <i class="fas fa-circle-notch fa-spin"></i>
  }
</button>
